/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  router selectors
 */

import { memoizeRouteProps } from '@zcode/memoizers'
import {
  APTS_BASE_URL,
  PROPERTY_TYPE_PATH_RE,
  getQueryBounds,
  isValidBounds,
} from '@zcode/nr-utils'
import type { Location } from 'history'
import type { StaticContext } from 'react-router'
import type { RouteComponentProps } from 'react-router-dom'

type RouteProps = RouteComponentProps<{}, StaticContext, unknown>

export const selectLocation = (routeProps: RouteProps): Location | undefined => routeProps?.location

export const selectRouteStartDate = memoizeRouteProps((routeProps: RouteProps) => {
  const { search } = selectLocation(routeProps) ?? {}
  const searchParams = new URLSearchParams(search)

  return searchParams.get('start-date')
})

export const selectRouteEndDate = memoizeRouteProps((routeProps: RouteProps) => {
  const { search } = selectLocation(routeProps) ?? {}
  const searchParams = new URLSearchParams(search)

  return searchParams.get('end-date')
})

export const selectBoxParam = memoizeRouteProps((routeProps: RouteProps) => {
  if (!routeProps) {
    return false
  }

  const searchParams = new URLSearchParams(routeProps.location?.search)
  const boxParam = searchParams.get('box')
  const box = getQueryBounds(boxParam)
  if (isValidBounds(box)) {
    return box
  }

  return null
})

export const getBasePath = memoizeRouteProps((routeProps: RouteProps) => {
  const path = routeProps.location?.pathname
  const propertyTypePath = PROPERTY_TYPE_PATH_RE.exec(path)

  return propertyTypePath ? propertyTypePath[0] : APTS_BASE_URL
})
